import { create } from 'zustand'

interface DealSycStore {
  isModalOpen: boolean
  isSyncingModalOpen: boolean
  isContactsInvitedModalOpen: boolean
  setIsModalOpen: (isModalOpen: boolean) => void
  setIsSyncingModalOpen: (isSyncingModalOpen: boolean) => void
  setIsContactsInvitedModalOpen: (isContactsInvitedModalOpen: boolean) => void
}

export const useDealSyncStore = create<DealSycStore>((set) => ({
  isModalOpen: false,
  isSyncingModalOpen: false,
  isContactsInvitedModalOpen: false,
  setIsModalOpen: (isModalOpen) => set({ isModalOpen }),
  setIsSyncingModalOpen: (isSyncingModalOpen) => set({ isSyncingModalOpen }),
  setIsContactsInvitedModalOpen: (isContactsInvitedModalOpen) =>
    set({ isContactsInvitedModalOpen }),
}))
